import dayjs from 'dayjs';

const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const useLocalizedDateTime = (
  date: string | Date,
  opt?: Intl.DateTimeFormatOptions,
) => {
  const dateObject = new Date(date);
  if (!window.Intl) {
    return dayjs(date).format('DD-MM-YYYY HH:mm');
  }

  return new Intl.DateTimeFormat(undefined, { ...options, ...opt }).format(
    new Date(dateObject),
  );
};
